<span [innerHTML]="data.nav"></span>
<br />
<small
  *ngIf="!suppressNavChange"
  [ngClass]="data.navChangeClass"
  [textContent]="data.navChange"
></small>
